import { render, staticRenderFns } from "./OtherDamageType.vue?vue&type=template&id=0dc1297e&scoped=true"
import script from "./OtherDamageType.vue?vue&type=script&lang=ts"
export * from "./OtherDamageType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1297e",
  null
  
)

export default component.exports